import { set } from 'lodash';
import produce from '@cld/immer';
import { STATUS_ACTION_TYPE, RESET_ACTION_TYPE } from './constants';
import actionMapper from './actionMapper';

const initialState = {};

const statusesReducer = (state = initialState, { type, status, name, error, statusSubCategoryName, types } = {}) => {
  switch (type) {
    case STATUS_ACTION_TYPE:
      if (status && type === STATUS_ACTION_TYPE) {
        return produce(state, (draftState) => {
          set(draftState, [name].concat(statusSubCategoryName ? statusSubCategoryName : []), {
            status,
            error,
          });
        });
      }

      return state;

    case RESET_ACTION_TYPE:
      if (types) {
        return produce(state, (draftState) => {
          types.forEach((type) => (draftState[type.TYPE || type] = undefined));
        });
      }

      return state;

    default:
      return state;
  }
};

export default (mapper = require('./apiMiddlewareMapper').default) => actionMapper(mapper)(statusesReducer);
